import { TriageFilterProvider } from "admin/components/diagnostics/TriageFilterContext";
import { TriageTable } from "admin/components/diagnostics/TriageTable";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { AdminPage } from "~/pages/manifold-nextgen/components/admin/AdminPage";

export const TurnDiagnostics = () => {
  useDocumentTitle("Turn Diagnostics");

  return (
    <AdminPage
      title="Turn Diagnostics"
      description="Triage the quality of individual agent turns"
      width="default"
    >
      <TriageFilterProvider>
        {/* Rubric dimensions come from the diagnostics summary endpoint, which the backend
            doesn't implement yet, so the detail drawer falls back to raw dimension names. */}
        <TriageTable rubricDimensions={[]} />
      </TriageFilterProvider>
    </AdminPage>
  );
};
